import React from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';
import './ImpersonationBanner.css';

/**
 * ImpersonationBanner Component
 * Displays a prominent warning banner when an admin is impersonating a merchant
 */
export default function ImpersonationBanner({ impersonationData, onExit }) {
  const formatDateTime = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner-content">
        <div className="impersonation-banner-info">
          <div className="impersonation-banner-icon">
            <AlertTriangle size={16} />
          </div>
          <div className="impersonation-banner-text">
            <div className="impersonation-banner-title">
              Admin Impersonation Mode
            </div>
            <div className="impersonation-banner-details">
              {impersonationData.adminEmail && (
                <span>Admin: {impersonationData.adminEmail}</span>
              )}
              {impersonationData.startedAt && (
                <>
                  <span className="impersonation-banner-separator">•</span>
                  <span>Since {formatDateTime(impersonationData.startedAt)}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <button
          className="impersonation-banner-exit-btn"
          onClick={onExit}
          title="Exit impersonation and return to admin dashboard"
        >
          <LogOut size={14} />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
}
